// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    CallAddRmaApi,
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";
import { RmaLineDto } from "@insite/client-framework/Types/ApiModels";
import { addRma } from "@vanmeter/App/Services/OrderHistoryService";
import { CustomAppState } from "@vanmeter/App/Store/Reducers";

export const xPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState() as CustomAppState;
    const orderLines = state.pages.requestRma.orderLines;

    const rmaLinesNotesMap = state.xCommon.rmaLinesNotesMap;

    if (orderLines.length === 0) {
        return false;
    }

    const safeMap = Array.isArray(rmaLinesNotesMap) ? rmaLinesNotesMap : [];

    props.apiParameter = {
        rmaModel: {
            orderNumber: props.parameter.orderNumber,
            notes: state.pages.requestRma.returnNotes || "",
            rmaLines: orderLines
                .map(orderLine => {
                    return {
                        line: orderLine.lineNumber,
                        rmaQtyRequested: orderLine.rmaQtyRequested,
                        rmaReasonCode: orderLine.returnReason,
                    } as RmaLineDto;
                })
                .filter(x => x.rmaQtyRequested > 0),
            // XNG-Changes:from classic
            properties: safeMap.length > 0 ? { rmaLinesNotes: JSON.stringify(safeMap) } : undefined,
        } as any,
    };
};

export const xCallAddRmaApi: typeof CallAddRmaApi = async props => {
    // XNG-Changes:use custom api
    props.apiResult = await addRma(props.apiParameter);
};

// Added to clear cartId state when submitting RMA to assure no conflict between cart and order data in confirmation page
export const ClearConfirmationCartId: typeof PopulateApiParameter = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "Pages/OnePageCheckoutConfirmation/BeginLoadCart",
            cartId: undefined,
        });
    }
};

replaceInChain(chain, PopulateApiParameter, xPopulateApiParameter);
replaceInChain(chain, CallAddRmaApi, xCallAddRmaApi);
addToEndOfChain(chain, ClearConfirmationCartId);
